<template>
  <div class="cb-input-group-addon input-group-addon">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'CbInputGroupAddon'
}
</script>
